module.exports = __webpack_public_path__ + "img/product_80.f864a49.webp";